@if (user$ | async; as user) {
  <div class="flex items-center justify-between">
    <div class="auth-user-card flex gap-4">
      <pt-user-icon
        [src]="
          user | map: profileImage.getUserProfileImage$ : profileImage | async
        "
        [diameter]="iconSize"
        [name]="user.name"
      />

      <div class="flex-1 truncate">
        <div class="flex flex-col">
          <div class="mat-subtitle-2 truncate">
            {{ user.name }}
          </div>
          <div class="truncate">{{ user.email }}</div>
        </div>
      </div>
    </div>
    <ng-content />
  </div>
}
